import React, { useState, useContext, useReducer, createContext, useMemo, useEffect } from 'react'
import { safeNull } from '../util/util'

export const storeContext = createContext({
    state: {},
    dispatch: () => { },
    triggers: {},
    setTriggers: () => { },
})

const gatherPersistentValues = (persistentKeys, state) => persistentKeys.reduce((a, c) => {
    a[c] = state[c]    
    return a
}, {})

export const StoreComponent = ({ children, reducer }) => {
    const init = safeNull(JSON.parse(sessionStorage.getItem('_red')))

    const [reducerState, dispatch] = useReducer(reducer?.reducer, init === undefined ? reducer?.initialState : {
        ...reducer?.initialState,
        ...init,
    })
    const [triggers, setTriggers] = useState({})

    useEffect(() => {
        const persistentValues = gatherPersistentValues(reducer?.persistentKeys, reducerState)
        sessionStorage.setItem('_red', JSON.stringify(persistentValues))
    }, [reducerState])

    return (
        <storeContext.Provider value={{
            state: reducerState, dispatch,
            triggers, setTriggers
        }}>
            {children}
        </storeContext.Provider>
    )
}

export const useDispatch = () => {
    const { dispatch } = useContext(storeContext)
    const proxyDispatch = (type, payload = undefined) => dispatch({ type, payload })
    return proxyDispatch
}

export const useSelector = (cb = (d) => d) => {
    const { state } = useContext(storeContext)
    return useMemo(() => cb(state), [cb, state])
}

const f = () => {}

export const useTrigger = (key) => {
    const { triggers } = useContext(storeContext)
    return triggers[key] || f
}

export const useRegisterTrigger = (key, cb) => {
    const { setTriggers } = useContext(storeContext)

    useEffect(() => {
        setTriggers((prev) => ({
            ...prev,
            [key]: cb,
        }))
    }, [])
}

export const createStoreHooks = () => {
    return { useDispatch, useSelector, useRegisterTrigger, useTrigger }
}

// use this if you do not need to override the store component
export default (reducer) => {
    return ({ children }) => <StoreComponent reducer={reducer}>{children}</StoreComponent>
}